export const selectModules = state => state.admin.global.modules;
export const selectCategories = state => state.admin.global.categories;



// WEBPACK FOOTER //
// ./src/routes/Admin/selectors.ts